import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import StateObserver from 'src/StateObserver';
import { waitForItPromise } from 'src/lib/utils';
import { duration } from 'src/replicant/utils/duration';

const MAINTENANCE_MODE_CONFIG = 'MAINTENANCE_MODE_CONFIG';
const MAINTENANCE_ENABLED_KEY = 'maintenanceModeEnabled';
const POLL_FREQ = duration({ seconds: 60 });

export default {
  // Do NOT await the init promise
  init: async () => {
    let popupOpen = false;
    // Poll kv store without emitter because we dont want to trigger
    // replicant calls everytime the state changes
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const resultKv = await StateObserver.replicant.internalKvStore.get(
        MAINTENANCE_MODE_CONFIG,
        { forceFetch: true }, // To not get a cached value
      );

      const parsedKv = JSON.parse(resultKv);
      if (!!parsedKv && parsedKv[MAINTENANCE_ENABLED_KEY] && !popupOpen) {
        popupOpen = true;
        await openPopupPromise('popupMaintenance', {});
      }

      // Do not spam replicant calls, once every minute should be good enough
      await waitForItPromise(POLL_FREQ);
    }
  },
};
